export const NITRO_CLAW_AGENT_NAME = 'nitro_claw';
